import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';

export type FeedbackType = 'bug' | 'feature' | 'general';

export interface CreateFeedbackRequest {
  type: FeedbackType;
  message: string;
  rating?: number;
  metadata?: Record<string, unknown>;
}

export interface FeedbackResponse {
  id: string;
  type: FeedbackType;
  message: string;
  rating: number | null;
  status: string;
  createdAt: string;
}

export interface CreateFeedbackResponse {
  message: string;
  feedback: FeedbackResponse;
}

export const feedbackApi = {
  createFeedback: async (data: CreateFeedbackRequest): Promise<CreateFeedbackResponse> => {
    const response = await apiClient.post(API_ENDPOINTS.FEEDBACK.CREATE, data);
    return response.data;
  },
};
